module.exports = __webpack_public_path__ + "01_very_short_black.305b2abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_very_short_black.png
// module id = 53jY
// module chunks = 0